import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3.5 22.2c.3-4.5 4-8 8.5-8s8.2 3.5 8.5 8z" }, null, -1),
    _createElementVNode("circle", {
      cx: "12",
      cy: "6.2",
      r: "4.5"
    }, null, -1)
  ]))]))
}
export default { render: render }